import React from 'react'
import SeoPage from '../components/SeoPage'

import Img from '../components/Image'
import { graphql, Link } from 'gatsby'

export default ({ data, location, ...props }) => (
    <SeoPage
        location={location}
        title="TOUS les moyens de défense contre une accusation d’alcool au volant!"
        description="“ Invoquez la MEILLEURE défense contre votre accusation d’alcool au volant – Consultez un avocat criminaliste spécialisé!">
        <p>
            Être arrêté pour alcool au volant ne veut pas dire que vous allez
            être reconnu coupable. En effet, devant le juge, il vous sera
            possible de soulever l’un des moyens de défense:
        </p>
        <ul>
            <li>La garde ou le contrôle insuffisant du véhicule,</li>
            <li>L’utilisation inadéquate de l’alcootest,</li>
            <li>Les délais indus entre les prélèvements d’haleine, ou </li>
            <li>Le non-respect des droits fondamentaux.</li>
        </ul>
        <p>
            <Img
                fluid={data.img0.childImageSharp.fluid}
                title="Quelles défenses pour l’alcool au volant?"
                alt="Une image contenant personne, voiture, téléphone mobile, fermer"
            />
        </p>
        <p>
            Si vous êtes en mesure de soulever l’un de ses moyens de défense,
            vous pourrez rejeter certaines preuves ou mettre fin aux procédures.{' '}
        </p>
        <p>
            <strong>
                Avocatsalcoolauvolant.ca vous présente TOUS les moyens de
                défense qui pourraient être soulevés afin de vous éviter une
                condamnation.
            </strong>
        </p>
        <p>
            <strong>
                Consultez ces moyens de défense juste ici et remplissez notre
                formulaire pour entrer en contact rapidement, et gratuitement
                avec un avocat qualifié en matière d’alcool au volant.{' '}
            </strong>
        </p>
        <h2>
            <strong>
                Quelles sont les conséquences si on vous trouve coupable
                d’alcool au volant?
            </strong>
        </h2>
        <p>
            Être arrêté ou reconnu coupable d’alcool au volant vient avec son
            lot de conséquences. Outre la suspension immédiate du permis de
            conduire, il faut prévoir:
        </p>
        <ul>
            <li>La saisie du véhicule,</li>
            <li>L’imposition d’un casier judiciaire, </li>
            <li>L’amende minimale de 1 000 $, et</li>
            <li>L’emprisonnement.</li>
        </ul>
        <p>
            La récidive ne fait qu’aggraver les conséquences en matière d’alcool
            au volant. EN voici la preuve!
        </p>
        <h3>
            <strong>Pour une première infraction d’alcool au volant</strong>
        </h3>
        <p>
            Une 1ère infraction reliée à l’alcool au volant vient avec une
            suspension administrative du permis de conduire{' '}
            <strong>pour 90 jours</strong>, une amende minimale de 1 000 $, une
            interdiction de conduire de 1 à 3 ans et un casier judiciaire.
        </p>
        <p>
            L’antidémarreur peut être installé pour conserver le droit de
            conduire pendant l’interdiction. Selon le taux d’alcool dans votre
            sang, l’amende peut atteindre la somme de 2 000 $.
        </p>
        <h3>
            <strong>Pour une seconde infraction d’alcool au volant</strong>
        </h3>
        <p>
            Une peine d’emprisonnement <strong>minimale de 30 jours</strong> est
            imposée lors d’une première récidive. Une interdiction de conduire
            de 3 mois sera imposée au conducteur. Il est possible d’avoir une
            interdiction supplémentaire qui varie entre 2 et 10 ans. Dans le cas
            d’une troisième infraction d’alcool au volant, la{' '}
            <strong>
                période minimale d’emprisonnement passe à 120 jours.
            </strong>
        </p>
        <p>
            Peu importe l’infraction, une chose est s
            <strong>ûre: la présence d’un avocat est nécessaire!</strong>
        </p>
        <h2>
            <strong>
                Alcool au volant : pourquoi avez-vous besoin d’un avocat
                criminaliste pour défendre?
            </strong>
        </h2>
        <p>
            Lorsque vous êtes accusé d’alcool au volant, vous avez besoin d’un
            avocat criminaliste pour les raisons suivantes:
        </p>
        <ul>
            <li>Il connaît les bonnes défenses, </li>
            <li>Il peut négocier avec les procureurs adverses, et</li>
            <li>Il peut vous représenter devant les tribunaux. </li>
        </ul>
        <p>
            <strong>
                <Img
                    fluid={data.img1.childImageSharp.fluid}
                    title="Avocat criminaliste accusation d’alcool au volant"
                    alt="Une image contenant intérieur, conteneur, verre"
                />
            </strong>
        </p>
        <p>
            L’expertise et les connaissances de l’avocat criminaliste sont sans
            égal en matière d’alcool au volant, et voici pourquoi vous avez
            intérêt à en engager un :
        </p>
        <h3>
            <strong>
                Un avocat qualifié sait comment choisir la bonne défense
            </strong>
        </h3>
        <p>
            Les défenses sont limitées en matière d’alcool au volant, et les
            moindres détails comptent pour obtenir un verdict de
            non-culpabilité. L’avocat criminaliste connaît suffisamment le
            système pour choisir la défense qui vous convient.
        </p>
        <h3>
            <strong>
                L’avocat en droit criminel peut négocier avec le procureur
            </strong>
        </h3>
        <p>
            Une accusation pour conduite avec les facultés affaiblies, ça se
            négocie! Il suffit que le procureur accepte de négocier, et que
            votre avocat le convainc d’abandonner le chef d’accusation.
        </p>
        <h3>
            <strong>
                Seul un avocat criminaliste peut vous défendre en cour
            </strong>
        </h3>
        <p>
            Devant le tribunal, seul un avocat est apte et autorisé à vous
            représenter devant le juge. Ses talents de plaideur sont mis à votre
            profit, ce qui maximise vos chances d’être déclaré non-coupable!
        </p>
        <h2>
            <strong>
                Quels sont les moyens de défense possibles en matière d’alcool
                au volant?
            </strong>
        </h2>
        <p>
            Les moyens de défense lorsque vous êtes accusé d’alcool au volant
            sont limités. Toutefois, il existe tout de même certaines options
            disponibles.{' '}
        </p>
        <h3>
            <strong>
                1) Preuve de conduite ou de garde et contrôle insuffisante
            </strong>
        </h3>
        <p>
            En droit criminel, c’est toujours la personne qui accuse qui doit
            démontrer que l’accusé a commis le crime hors de tout doute
            raisonnable.{' '}
        </p>
        <p>
            Il est possible d’attaquer la preuve récoltée par les policiers et
            par le procureur en plaidant qu’elle{' '}
            <strong>
                ne permet pas de conclure hors de tout doute raisonnable
            </strong>{' '}
            que l’accusé a conduit son véhicule en état d’ébriété. LIl est
            possible d’attaquer l’accusation de garde et contrôle.
        </p>
        <p>
            Cette accusation vise les individus accusés d’avoir assumé la garde
            et le contrôle d’un véhicule avec un taux d’alcool supérieur à la
            limite permise. Le fait de prouver qu’il n’existait aucun risque de
            mettre le véhicule en marche ou que le conducteur avait un plan
            alternatif peut permettre de se sortir d’impasse.
        </p>
        <h3>
            <strong>2) Utilisation inadéquate de l’alcootest (ADA)</strong>
        </h3>
        <p>
            Il est possible de reprocher aux policiers d’avoir négligé les
            règles de l’art quant à la manipulation de l’alcootest.
        </p>
        <p>
            <strong>L’utilisation d’un alcootest non conforme </strong>peut
            servir de moyen de défense, car le résultat de ce même test est la
            preuve la plus incriminante contre l’accusé.
        </p>
        <p>
            <strong>
                <Img
                    fluid={data.img2.childImageSharp.fluid}
                    title="Défense d’utilisation inadéquate de l’alcootest"
                    alt="Une image contenant personne, voiture, véhicule, fauteuil"
                />
            </strong>
        </p>
        <p>
            La loi encadre également le type d’alcootest que les policiers
            peuvent faire passer aux conducteurs, et ils doivent utiliser un
            appareil de détection approuvé (ADA) pour que le résultat soit
            utilisable en preuve.
        </p>
        <p>
            Voici les principaux moyens de se défendre en contestant
            l’exactitude d’un alcootest :
        </p>
        <ul>
            <li>Utilisation déficiente de l’alcootest</li>
            <li>Entretien inadéquat de l’appareil (ADA)</li>
            <li>Délais indus dans la passation du test</li>
            <li>Appareil de détection non approuvé</li>
        </ul>
        <h3>
            <strong>3) Délai indu dans la prise d’échantillon d’haleine</strong>
        </h3>
        <p>
            La prise d’un échantillon d’haleine doit être effectuée sans délai
            lors de l’arrestation d’un conducteur.
        </p>
        <p>
            Lorsque les policiers ne soumettent pas le conducteur à un test de
            détection d’alcool dans l’immédiat, le conducteur peut faire valoir
            une défense basée sur les délais indus reliés au test de dépistage.
        </p>
        <p>
            Lors de décisions récentes, des juges ont accepté d’écarter le
            résultat de l’alcootest effectué par les policiers, car ces derniers
            avaient attendu{' '}
            <strong>
                près de 20 minutes avant de le faire passer au conducteur.
            </strong>
        </p>
        <p>
            Le test doit se faire immédiatement, sans quoi les critères prévus
            par la loi ne seront pas respectés.
        </p>
        <h3>
            <strong>
                4) Non-respect des droits fondamentaux du conducteur
            </strong>
        </h3>
        <p>
            Les défenses en vertu de la Charte canadienne font partie des plus
            efficaces en matière d’alcool au volant. Lorsque les droits
            fondamentaux du conducteur sont bafoués, il est possible d’exclure
            certains éléments de preuve!
        </p>
        <h4>
            <strong>Non-respect du droit à un avocat</strong>
        </h4>
        <p>
            Dès votre arrestation, le conducteur doit être informé sans délai de
            son droit de consulter un avocat. Un manquement d’informer le
            conducteur de ce droit peut justifier le retrait des accusations.
        </p>
        <h4>
            <strong>Fouille abusive et arrestation arbitraire</strong>
        </h4>
        <p>
            <strong>
                Les policiers ont effectué une fouille du véhicule sans mandat
                ou de façon abusive? L’interception du véhicule s’est faite sans
                raison et de façon illégale?{' '}
            </strong>
            Si les droits fondamentaux de l’accusé ont été violés lors de telles
            procédures, un avocat pourra plaider en faveur du retrait des
            accusations.
        </p>
        <p>
            <strong>ATTENTION!</strong> Depuis déjà quelques années, les
            policiers n’ont plus besoin d’avoir des soupçons ou des « motifs
            raisonnables » de croire qu’un conducteur est intoxiqué pour lui
            faire passer un alcootest. Tout policier qui a un appareil approuvé
            en sa possession peut contraindre un conducteur à s’y soumettre.
        </p>
        <h3>
            <strong>5) Défense du dernier verre ou du verre d’après</strong>
        </h3>
        <p>
            De telles défenses sont-elles toujours valides en matière d’alcool
            au volant?
        </p>
        <p>
            Malheureusement, le glas a sonné pour les défenses du verre d’après
            et celle du dernier verre. Les nouvelles lois sont venues anéantir
            de telles défenses, choses que les tribunaux ont reconnus.
        </p>
        <p>
            La défense du verre d’après consistait à plaider que l’accusé{' '}
            <strong>avait consommé de l’alcool après avoir conduit,</strong>{' '}
            mais avant de se soumettre au test, car il n’avait aucune raison de
            croire qu’un tel test lui serait exigé.
        </p>
        <p>
            Avec la défense du dernier verre, l’accusé prétendait avoir consommé
            son dernier verre d’alcool tout juste avant de prendre le volant.
            Comme il venait tout juste de boire l’alcool, les effets ne se
            faisaient donc pas ressentir sur ses facultés, même si l’alcootest
            avait été échoué.
        </p>
        <h2>
            <strong>
                Absolution ou retrait d’accusations : est-ce possible en matière
                d’alcool au volant?
            </strong>
        </h2>
        <p>
            Non, l’absolution n’est pas possible lors d'accusations d’alcool au
            volant puisqu’il y a une peine minimale qui s’applique.{' '}
        </p>
        <p>
            <Img
                fluid={data.img3.childImageSharp.fluid}
                title="Retrait des accusations d’alcool au volant"
                alt="Une image contenant voiture, personne, fauteuil, siège de voiture"
            />
        </p>
        <p>
            L’absolution est prévue au Code criminel qui évite à l’accusé
            d’hériter d’un casier judiciaire. Elle peut être inconditionnelle ou
            conditionnelle. Dans ce dernier cas, l’accusé devra respecter
            certaines conditions pour profiter des effets de l’absolution.{' '}
            <strong>
                Cette sentence clémente ne s’applique que si l’infraction n’a
                pas de peine minimale.
            </strong>
        </p>
        <p>
            C’est pourquoi le retrait des accusations ou la préparation d’une
            défense solide sont aussi importants en matière d’alcool au volant
        </p>
        <h2>
            <strong>
                Plaider coupable peut-il être avantageux en matière d’alcool au
                volant?
            </strong>
        </h2>
        <p>
            <strong>
                Les plaidoyers de culpabilité sont fréquents en matière d’alcool
                au volant.{' '}
            </strong>
            Il arrive que la preuve récoltée par la poursuite soit simplement
            trop incriminante.Plaider coupable peut venir avec des avantages au
            niveau de la sentence!
        </p>
        <p>
            La peine minimale prévue au Code criminel sera imposée au conducteur
            même s’il plaide coupable. Toutefois, un juge pourrait autoriser un
            conducteur à conserver son droit de conduire malgré la période
            d’interdiction, à condition qu’il ait un motif suffisant.
        </p>
        <p>
            Chose certaine, il ne faut surtout pas plaider coupable avant
            d’avoir exploré ses options avec un avocat criminaliste spécialisé
            en accusations d’alcool au volant.
        </p>
        <h2>
            <strong>
                Consultez un avocat pour invoquer le bon moyen de défense contre
                votre accusation!
            </strong>
        </h2>
        <p>
            Un verdict de culpabilité en matière d’alcool au volant peut venir
            avec de lourdes conséquences.
        </p>
        <p>
            <strong>
                <Img
                    fluid={data.img4.childImageSharp.fluid}
                    title="Meilleure défense contre l’alcool au volant"
                    alt="Une image contenant texte, table, personne, guichet"
                />
            </strong>
        </p>
        <p>
            Du casier judiciaire jusqu’au permis révoqué en passant par les
            amendes salées, sachez qu’un tel verdict peut grandement affecter
            votre vie.
        </p>
        <p>
            <strong>
                Il est donc très important de vous entourer des bons
                professionnels comme l’avocat en droit criminel pour vous
                défendre contre une telle accusation.
            </strong>
        </p>
        <p>
            <strong>
                Et ça tombe bien, car on vous propose justement de vous référer
                à l’un d’entre eux gratuitement, et sans engagement. Il ne reste
                qu’à remplir notre formulaire, et on s’occupe du reste!
            </strong>
        </p>
    </SeoPage>
)

export const pageQuery = graphql`
    query ($language: String!) {
        locales: allLocale(filter: { language: { eq: $language } }) {
            edges {
                node {
                    ns
                    data
                    language
                }
            }
        }
        img0: file(
            relativePath: {
                eq: "defenses-alcool-volant/moyens-defense-alcool-volant.jpeg"
            }
        ) {
            childImageSharp {
                fluid(maxWidth: 960) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
        img1: file(
            relativePath: {
                eq: "defenses-alcool-volant/avocat-criminaliste-alcool-volant.jpeg"
            }
        ) {
            childImageSharp {
                fluid(maxWidth: 960) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
        img2: file(
            relativePath: {
                eq: "defenses-alcool-volant/mauvaise-utilisation-alcootest-policiers.jpeg"
            }
        ) {
            childImageSharp {
                fluid(maxWidth: 960) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
        img3: file(
            relativePath: {
                eq: "defenses-alcool-volant/retrait-accusations-alcool-volant.jpeg"
            }
        ) {
            childImageSharp {
                fluid(maxWidth: 960) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
        img4: file(
            relativePath: {
                eq: "defenses-alcool-volant/meilleure-defense-facultes-affaiblies.jpeg"
            }
        ) {
            childImageSharp {
                fluid(maxWidth: 960) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
    }
`
